'use strict';

var App = require('app');
var AppState = require('app_state');
var CommonViews = require('components/common/views');
var i18n = require('utils/i18n');
var MiniaturSchemes = require('components/devices/views/gateway/miniatur_schemes');
var SchemeLayoutView = require('components/scheme/views/layout_view');

var GatewayDashboard = Marionette.LayoutView.extend({
    template: require('components/devices/templates/gateway/gateway_dashboard'),

    regions: {
        main: '.js-main-region',
    },

    initialize: function (data) {
        this.controllerCollection = data.controllerList;
        this.models = data.controllerList.items.models;
        this.gateway = data.gateway;
        this.hasOwnSchema = data.hasOwnSchema;
    },

    setPermission: function (permissions) {},

    onRender: function () {
        // show schema view
        if (this.models.length === 1 || this.hasOwnSchema) {
            this.showSchema(this.hasOwnSchema);
            return;
        }

        // show dashboard
        this.showChildView(
            'main',
            new MiniaturSchemes({
                ctrlCollection: this.controllerCollection,
                models: this.models,
            })
        );
    },

    showSchema: function (hasOwnSchema) {
        var schema = false;
        var schemaModel = this.models[0];

        // Has the gateway its own schema?
        if (hasOwnSchema) {
            // gateway has own schema -> do not load circuit values, gateway becomes schema model
            schemaModel = this.gateway;
        } else {
            // load controller schema
            schema = App.request('circuit:model', this.models[0].id, 0, 'schema');
        }
        var sensorValues = App.request('device:sensors', schemaModel.id);
        var permissions = App.request('permissions:me', schemaModel.id);
        var inconsistent = App.request('device:inconsistent', schemaModel);
        var valueList = App.request('device:values', schemaModel.id);
        var sidebarConfig = App.request('device:scheme-config', [schemaModel.id]);
        var hcsConfig = App.request('device:hcs-config', schemaModel.id);
        var smartTempInfo = App.request('device:smarttemp', schemaModel.id, true);

        var self = this;
        $.when(
            schema,
            sensorValues,
            inconsistent,
            permissions,
            valueList,
            sidebarConfig,
            smartTempInfo,
            hcsConfig
        ).done(function (schema, sensorValues, inconsistent, perm, valueList, sidebarConfig, smartTempInfo, hcsConfig) {
            if (schema === undefined || sensorValues === undefined) {
                // could not load schema
                var contentView = new CommonViews.Message({
                    title: i18n.TR('Fehler'),
                    text: i18n.TR('Anlagenschemadaten konnten nicht geladen werden.'),
                    color_class: 'box-color-error',
                    action_label: i18n.TR('Zurück zur Übersicht'),

                    action_cb: function () {
                        self.showChildView(
                            'main',
                            new MiniaturSchemes({
                                ctrlCollection: self.controllerCollection,
                                models: self.models,
                            })
                        );
                    },
                });
                self.showChildView('main', contentView);
                return;
            }

            var CtrController = require('components/devices/controllers/controller');
            var controller = new CtrController({ deviceCategory: '55xx56xx' });
            var view = new SchemeLayoutView({
                model: schemaModel,
                controller: controller,
                schema: schema,
                inconsistent: inconsistent,
                columns: AppState.availableColumns(),
                sensorValues: sensorValues,
                tabs: controller.initTabs(schemaModel, permissions),
                activeTab: 0,
                permissions: perm.data,
                valueList: valueList,
                sidebarConfig: sidebarConfig,
                smartTempInfo: smartTempInfo,
                hcsConfig: hcsConfig,
            });
            view.setPermission(perm.data);

            self.showChildView('main', view);
        });
    },
});

module.exports = GatewayDashboard;
